import {
  allProjectsClient,
  CurrentProject,
  currentProjectClient,
  Project,
} from 'common/report/queries/app-api/project-metadata-client';
import {getProjectId} from 'common/report/util';
import {ApiResource, ApiSingleValueResource} from 'common/util/model-resource/api-resource';

export {CurrentProject, Project};

export class ProjectsResource extends ApiResource<Project> {
  apiClient = allProjectsClient;
}

export class CurrentProjectResource extends ApiSingleValueResource<CurrentProject> {
  apiClient = currentProjectClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
  }
}
